<template>
  <div class="post-page">
    <div class="w-1200">
      <!-- 搜索栏 -->
      <div class="top-box">
        <el-form label-position="right" :model="form" label-width="70px">
          <el-row>
            <el-col :span="5">
              <el-form-item label="类型">
                <el-select v-model="searchForm.type" placeholder="请选择类型">
                  <el-option label="全部" value="0"></el-option>
                  <el-option label="工厂方" value="1"></el-option>
                  <el-option label="需求方" value="2"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="5" :offset="1">
              <el-form-item label="标题">
                <el-input v-model="searchForm.title" placeholder="请输入标题"/>
              </el-form-item>
            </el-col>
            <el-col :span="8" :offset="1">
              <el-form-item label="发布时间">
                <el-date-picker v-model="searchForm.created_at" type="daterange" range-separator="至"
                                start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"/>
              </el-form-item>
            </el-col>
            <el-col :span="4" class="flex-end">
              <gradient-button background="#0C60E6" @hit="handleSearch">搜索</gradient-button>
              <gradient-button @hit="handleReset" color="#5F616C" border="1px solid #5F616C" background="transparent">刷新
              </gradient-button>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <!-- 切换栏 -->
      <div class="content-box">
        <div class="content-box-left">加工供需</div>
        <gradient-button background="#0C60E6" @hit="handleRelease">新增</gradient-button>
      </div>
      <!-- 表格 -->
      <div class="fotter-box">
        <div class="teble" v-loading="loading">
          <el-table ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%" :header-cell-style="{
            backgroundColor: '#F6F6F8',
            textAlign: 'center',
          }" :cell-style="{ textAlign: 'center' }">
            <!-- <el-table-column type="selection" width="92"> </el-table-column> -->
            <el-table-column prop="id" label="编号"></el-table-column>
            <el-table-column prop="type" label="类型">
              <template slot-scope="scope">
                <span v-if="scope.row.type == 1">工厂方</span>
                <span v-if="scope.row.type == 2">需求方</span>
              </template>
            </el-table-column>
            <el-table-column prop="title" label="标题"></el-table-column>
            <el-table-column prop="created_at" label="发布时间" width="200">
            </el-table-column>

            <el-table-column prop="phone" label="联系电话"></el-table-column>

            <!-- <el-table-column prop="worker_size" label="工人规模(人)">
            </el-table-column> -->
            <el-table-column fixed="right" label="操作" width="190">
              <template slot-scope="scope">
                <div class="operation">
                  <el-button @click="handleClick(scope.row)" type="text" size="small">查看</el-button>
                  <el-button type="text" size="small" @click="handleEdit(scope.row)">编辑</el-button>
                  <el-button type="text" size="small" @click="handleDelete(scope.row)">删除</el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="pagination-box">
          <el-pagination class="float-right" @size-change="handleSizeChange" @current-change="handleCurrentChange"
                         :current-page="page" :page-sizes="[10, 20, 30, 40]" :page-size="pageSize" background
                         layout="total, sizes, prev, pager, next, jumper" :total="total">
          </el-pagination>
        </div>
      </div>
    </div>

    <!-- 新增表单弹窗 -->
    <el-dialog :close-on-press-escape="false" :close-on-click-modal="false" :modal-append-to-body="false"
               title="新增加工供需"
               :visible.sync="dialogVisible" width="60%" :before-close="handleClose">
      <el-form class="form-box" :model="form" ref="form" label-width="150px" :rules="rules" v-if="formType === 1">
        <el-form-item label="类型">
          <el-radio-group v-model="form.type" prop="type" @change="changeType">
            <el-radio :label="1">工厂方</el-radio>
            <el-radio :label="2">需求方</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="标题" prop="title">
          <el-input v-model="form.title" placeholder="请输入标题"></el-input>
        </el-form-item>
        <el-row>
          <el-col :span="12">
            <el-form-item label="园区名称" prop="park_name">
              <el-input v-model="form.park_name" placeholder="请输入园区名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="园区等级" prop="park_level">
              <el-radio-group v-model="form.park_level">
                <el-radio :label="1">国家级</el-radio>
                <el-radio :label="2">省级</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="占地面积(m²)" prop="space">
              <el-input v-model="form.space" placeholder="请输入占地面积">
                <template slot="append">m²</template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="工人规模(人)" prop="worker_size">
              <el-input v-model="form.worker_size" placeholder="请输入工人规模">
                <template slot="append">人</template>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="联系电话" prop="phone">
              <el-input v-model="form.phone" placeholder="请输入联系电话"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="工人工作时间" prop="work_type">
              <el-select v-model="form.work_type" placeholder="请选择">
                <el-option label="无倒班" :value="1"></el-option>
                <el-option label="两班倒" :value="2"></el-option>
                <el-option label="三班倒" :value="3"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="小实验室" prop="small_libaray">
              <el-radio-group v-model="form.small_libaray">
                <el-radio :label="1">有</el-radio>
                <el-radio :label="2">无</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="工厂网址" prop="website">
              <el-input v-model="form.website" placeholder="请输入工厂网址"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="生产所在地" prop="address">
              <el-cascader v-model="form.address" :options="areaOptions"></el-cascader>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="反应温度" prop="temperature">
              <el-input v-model="form.temperature"
                        placeholder="请输入最低温和最高温；如：最低温度-20度，最高温度150度"></el-input>
              <!--              <el-input v-model="form.temperature"-->
              <!--                        placeholder=""></el-input>-->
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-form-item label="特色加工" prop="special_machining">
            <el-checkbox-group v-model="checkList" @change="changeFeaturedProcessing">
              <el-checkbox v-for="(item, index) in featuredProcessingList" :key="index"
                           :label="item.label"></el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </el-row>
        <el-row>

        </el-row>
        <div class="from-three">
          <el-form-item label="三废处理" prop="three_wastes">
            <div class="from-three-content">
              <div>
                <el-row>
                  <el-col :span="8">
                    <el-form-item label="废水处理能力">
                      <el-radio-group v-model="form.three_wastes.water.enable">
                        <el-radio :label="1">是</el-radio>
                        <el-radio :label="2">否</el-radio>
                      </el-radio-group>
                    </el-form-item>
                  </el-col>
                  <div v-if="form.three_wastes.water.enable === 1">
                    <el-col :span="7">
                      <el-input v-model="form.three_wastes.water.number" placeholder="每天可处理的数量"></el-input>
                    </el-col>
                    <el-col :span="7" :offset="2">
                      <el-input v-model="form.three_wastes.water.price" placeholder="处理价格"></el-input>
                    </el-col>
                  </div>
                </el-row>
              </div>
              <div>
                <el-row>
                  <el-col :span="8">
                    <el-form-item label="废气处理能力">
                      <el-radio-group v-model="form.three_wastes.tag.enable">
                        <el-radio :label="1">是</el-radio>
                        <el-radio :label="2">否</el-radio>
                      </el-radio-group>
                    </el-form-item>
                  </el-col>
                  <div v-if="form.three_wastes.tag.enable === 1">
                    <el-col :span="7">
                      <el-input v-model="form.three_wastes.tag.number" placeholder="每天可处理的数量"></el-input>
                    </el-col>
                    <el-col :span="7" :offset="2">
                      <el-input v-model="form.three_wastes.tag.price" placeholder="处理价格"></el-input>
                    </el-col>
                  </div>
                </el-row>
              </div>
              <div>
                <el-row>
                  <el-col :span="8">
                    <el-form-item label="废固处理能力">
                      <el-radio-group v-model="form.three_wastes.solid.enable">
                        <el-radio :label="1">是</el-radio>
                        <el-radio :label="2">否</el-radio>
                      </el-radio-group>
                    </el-form-item>
                  </el-col>
                  <div v-if="form.three_wastes.solid.enable === 1">
                    <el-col :span="7">
                      <el-input v-model="form.three_wastes.solid.number" placeholder="每天可处理的数量"></el-input>
                    </el-col>
                    <el-col :span="7" :offset="2">
                      <el-input v-model="form.three_wastes.solid.price" placeholder="处理价格"></el-input>
                    </el-col>
                  </div>
                </el-row>
              </div>
            </div>
          </el-form-item>
          <!-- <div class="from-three-title">三废处理</div> -->
        </div>
        <div class="table-from">
          <div class="table-from-title">
            <div>设备及数量</div>
            <el-button type="primary" @click="addDevice">新增</el-button>
          </div>
          <div>
            <el-table :data="equipmentList" style="width: 100%" :header-cell-style="{
              backgroundColor: '#D1E1FB',
              color: '#00112B',
            }">
              <el-table-column type="index" label="序号" width="180">
              </el-table-column>
              <el-table-column prop="equip" label="设备类型" width="180">
              </el-table-column>
              <el-table-column prop="number" label="数量"></el-table-column>
              <el-table-column label="操作">
                <template slot-scope="scope">
                  <el-button type="text" size="small" @click="deleteDevice(scope.row.id, scope.$index)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <el-form-item label="资源描述" prop="desc">
          <el-input type="textarea" placeholder="请输入" v-model="form.desc"></el-input>
        </el-form-item>
      </el-form>

      <el-form class="form-box" :model="formTwo" ref="formTwo" label-width="150px" :rules="rulesTwo"
               v-if="formType === 2">
        <el-form-item label="类型" prop="type">
          <el-radio-group v-model="formTwo.type" prop="type" @change="changeType">
            <el-radio :label="1">工厂方</el-radio>
            <el-radio :label="2">需求方</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="标题" prop="title">
          <el-input v-model="formTwo.title" placeholder="请输入标题"></el-input>
        </el-form-item>
        <el-form-item label="技术成熟度" prop="technology">
          <el-radio-group v-model="formTwo.technology">
            <el-radio label="1">小试技术</el-radio>
            <el-radio label="2">中试技术</el-radio>
            <el-radio label="3">产业化技术</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-row>
          <el-col :span="12">
            <el-form-item label="危险反应" prop="is_danger">
              <el-radio-group v-model="formTwo.is_danger">
                <el-radio :label="1">是</el-radio>
                <el-radio :label="2">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="原料办证" prop="is_cert">
              <el-radio-group v-model="formTwo.is_cert">
                <el-radio :label="1">是</el-radio>
                <el-radio :label="2">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="生产数量" prop="product_number">
              <el-input v-model="formTwo.product_number" placeholder="请输入生产数量"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="加工费用" prop="processing_cost">
              <el-input v-model="formTwo.processing_cost" placeholder="请输入加工费用"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="废水数量" prop="wastewater_num">
              <el-input v-model="formTwo.wastewater_num" placeholder="请输入废水数量"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="废气数量" prop="wastegas_num">
              <el-input v-model="formTwo.wastegas_num" placeholder="请输入废气数量"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="废固数量" prop="waste_solids_num">
              <el-input v-model="formTwo.waste_solids_num" placeholder="请输入废固数量"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系电话" prop="phone">
              <el-input v-model="formTwo.phone" placeholder="请输入联系电话"></el-input>
            </el-form-item>
          </el-col>
        </el-row>


        <el-form-item label="设备要求" prop="equipment_requirement">
          <el-input v-model="formTwo.equipment_requirement" placeholder="请输入设备要求"></el-input>
        </el-form-item>


        <el-form-item label="需求详细描述" prop="detile">
          <el-input v-model="formTwo.detile" type="textarea" placeholder="请输入需求详细描述"></el-input>
        </el-form-item>

        <el-form-item label="需求截止时间" prop="upto_at">
          <el-date-picker v-model="formTwo.upto_at" type="date" placeholder="选择日期"
                          value-format="yyyy-MM-dd"></el-date-picker>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 新增设备和数量 -->
    <el-dialog :close-on-press-escape="false" :close-on-click-modal="false" :modal-append-to-body="false"
               title="新增设备和数量" :visible.sync="addDeviceVisible" width="30%">
      <el-form :model="addDeviceForm" :rules="addDeviceRules" ref="addDeviceForm" label-width="100px">
        <el-form-item label="设备类型" prop="equip">
          <el-input v-model="addDeviceForm.equip" placeholder="请输入设备类型"></el-input>
        </el-form-item>
        <el-form-item label="数量" prop="number">
          <el-input v-model="addDeviceForm.number" placeholder="请输入数量如：100台"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addDeviceVisible = false">取 消</el-button>
        <el-button type="primary" @click="addDeviceSubmit">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 查看 -->
    <el-dialog :close-on-press-escape="false" :close-on-click-modal="false" :modal-append-to-body="false" title="查看"
               :visible.sync="detailVisible" width="60%">
      <div class="detail-box">
        <table v-if="detail.type == 1" border="1" class="detail-table">
          <tr>
            <td>类型</td>
            <td>工厂方</td>
            <td>标题</td>
            <td>{{ detail.title }}</td>
            <td>联系电话</td>
            <td>{{ detail.phone }}</td>
          </tr>
          <tr>
            <td>园区名称</td>
            <td>{{ detail.park_name }}</td>
            <td>园区等级</td>
            <td>{{ detail.park_level == 1 ? "国家级" : "省级" }}</td>
            <td>占地面积</td>
            <td>{{ detail.space }}</td>
          </tr>
          <tr>
            <td>工人规模</td>
            <td>{{ detail.worker_size }}</td>
            <td>工人工作时间</td>
            <td v-if="detail.work_type == 1">无倒班</td>
            <td v-if="detail.work_type == 2">两班倒</td>
            <td v-if="detail.work_type == 3">三班倒</td>
            <td>工厂网址</td>
            <td>{{ detail.website || "--" }}</td>
          </tr>
          <tr>
            <td>小实验室</td>
            <td>{{ detail.small_libaray == 1 ? "是" : "否" }}</td>
            <td>生产所在地</td>
            <td>
              {{ detail.address.province }}{{
                detail.address.city
              }}{{ detail.address.area }}
            </td>
            <td>特色加工</td>
            <td>
              <el-tag v-for="(item, index) in detail.special_machining" :key="index">{{ item }}</el-tag>
            </td>
          </tr>
          <tr>
            <td>废水处理能力</td>
            <td>{{ detail.three_wastes.water.enable == 1 ? "是" : "否" }}</td>
            <td>每天可处理的数量</td>
            <td>{{ detail.three_wastes.water.number || "--" }}</td>
            <td>处理价格</td>
            <td>{{ detail.three_wastes.water.price || "--" }}</td>
          </tr>
          <tr>
            <td>废气处理能力</td>
            <td>{{ detail.three_wastes.tag.enable == 1 ? "是" : "否" }}</td>
            <td>每天可处理的数量</td>
            <td>{{ detail.three_wastes.tag.number || "--" }}</td>
            <td>处理价格</td>
            <td>{{ detail.three_wastes.tag.price || "--" }}</td>
          </tr>
          <tr>
            <td>废固处理能力</td>
            <td>{{ detail.three_wastes.solid.enable == 1 ? "是" : "否" }}</td>
            <td>每天可处理的数量</td>
            <td>{{ detail.three_wastes.solid.number || "--" }}</td>
            <td>处理价格</td>
            <td>{{ detail.three_wastes.solid.price || "--" }}</td>
          </tr>
          <tr>
            <td>反应温度</td>
            <td>{{ detail.temperature || "--" }}</td>
            <td>资源描述</td>
            <td :colspan="5">{{ detail.desc || "--" }}</td>
          </tr>
        </table>
        <table v-if="detail.type == 1" border="1" class="detail-table margin-top">
          <tr>
            <td :colspan="4" class="text-center">设备及数量</td>
          </tr>
          <tr v-for="(item, index) in detail.equipment" :key="index">
            <td>设备类型</td>
            <td>{{ item.equip }}</td>
            <td>数量</td>
            <td>{{ item.number }}</td>
          </tr>
        </table>
        <table v-if="detail.type == 2" border="1" class="detail-table">
          <tr>
            <td>类型</td>
            <td>需求方</td>
            <td>标题</td>
            <td>{{ detail.title }}</td>
            <td>联系电话</td>
            <td>{{ detail.phone }}</td>
          </tr>
          <tr>
            <td>技术成熟度</td>
            <td>{{ detail.technology == 1 ? "小试技术" : "中试技术" }}</td>
            <td>危险反应</td>
            <td>{{ detail.is_danger == 1 ? "是" : "否" }}</td>
            <td>原料办证</td>
            <td>{{ detail.is_cert == 1 ? "是" : "否" }}</td>
          </tr>
          <tr>
            <td>生产数量</td>
            <td>{{ detail.product_number }}</td>
            <td>加工费用</td>
            <td>{{ detail.processing_cost }}</td>
            <td>需求截止时间</td>
            <td>{{ detail.upto_at }}</td>
          </tr>
          <tr>
            <td>废水数量</td>
            <td>{{ detail.wastewater_num }}</td>
            <td>废气数量</td>
            <td>{{ detail.wastegas_num }}</td>
            <td>废固数量</td>
            <td>{{ detail.waste_solids_num }}</td>
          </tr>
          <tr>
            <td>设备要求</td>
            <td :colspan="5">{{ detail.equipment_requirement }}</td>
          </tr>
          <tr>
            <td>需求详细描述</td>
            <td :colspan="5">{{ detail.detile }}</td>
          </tr>
        </table>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import gradientButton from "@/components/button/gradient-button.vue";
import {getDictValuesByKey, getAreaOptions} from "@/api/modules/common.js";
import {
  processAdd,
  processList,
  procesDetail,
  procesEdit,
} from "@/api/modules/user.js";
import {procesDelete} from "../../api";

export default {
  components: {gradientButton},
  name: "process",

  data() {
    return {
      checkList: [],
      searchForm: {
        type: "",
        title: "",
        created_at: [],
      },
      detailVisible: false,
      loading: false,
      formType: 1,
      addDeviceVisible: false,
      addDeviceForm: {
        equip: "",
        number: "",
      },
      addDeviceRules: {
        equip: [{required: true, message: "请选择设备类型", trigger: "blur"}],
        number: [{required: true, message: "请输入数量", trigger: "blur"}],
      },
      // 设备和数量k列表
      equipmentList: [],
      // 省市区
      areaOptions: [],
      input: "",
      formData: {
        cas: "",
        code: "",
        invoice: "",
        publishTime: "",
      },
      dialogVisible: false,
      form: {
        type: 1,
        title: "",
        phone: "",
        park_name: "",
        park_level: 1,
        space: "",
        worker_size: "",
        work_type: 1,
        small_libaray: 1,
        website: "",
        address: [],
        special_machining: [],
        temperature: '',
        three_wastes: {
          water: {
            enable: 2,
            number: "",
            price: "",
          },
          tag: {
            enable: 2,
            number: "",
            price: "",
          },
          solid: {
            enable: 2,
            number: "",
            price: "",
          },
        },
        equipment: [],
        desc: "",
      },
      rules: {
        type: [{required: true, message: "请选择类型", trigger: "blur"}],
        title: [{required: true, message: "请输入标题", trigger: "blur"}],
        phone: [
          {required: true, message: "请输入手机号", trigger: "blur"},
          {
            pattern: /^1[3-9]\d{9}$/,
            message: "请输入正确的手机号码",
            trigger: "blur",
          },
        ],
        park_name: [
          {required: true, message: "请输入园区名称", trigger: "blur"},
        ],
        park_level: [
          {required: true, message: "请选择园区等级", trigger: "blur"},
        ],
        space: [{required: true, message: "请输入占地面积", trigger: "blur"}],
        worker_size: [
          {required: true, message: "请输入工人规模", trigger: "blur"},
        ],
        work_type: [
          {required: true, message: "请选择工人工作时间", trigger: "blur"},
        ],
        small_libaray: [
          {required: true, message: "请选择小实验室", trigger: "blur"},
        ],
        address: [
          {required: true, message: "请选择生产所在地", trigger: "blur"},
        ],
        special_machining: [
          {required: true, message: "请选择特色加工", trigger: "blur"},
        ],
        temperature: [
          {required: true, message: "请输入反应温度", trigger: "blur"},
        ],
        three_wastes: [
          {required: true, message: "请选择三废处理", trigger: "blur"},
        ],
        desc: [{required: true, message: "请输入资源描述", trigger: "blur"}],
      },
      formTwo: {
        type: 2,
        title: "",
        technology: "",
        is_danger: 1,
        is_cert: 1,
        product_number: "",
        processing_cost: "",
        wastewater_num: "",
        wastegas_num: "",
        waste_solids_num: "",
        equipment_requirement: "",
        detile: "",
        phone: "",
        upto_at: "",
      },
      rulesTwo: {
        type: [{required: true, message: "请选择类型", trigger: "blur"}],
        title: [{required: true, message: "请输入标题", trigger: "blur"}],
        technology: [
          {required: true, message: "请选择技术成熟度", trigger: "blur"},
        ],
        is_danger: [
          {required: true, message: "请选择危险反应", trigger: "blur"},
        ],
        is_cert: [
          {required: true, message: "请选择原料办证", trigger: "blur"},
        ],
        product_number: [
          {required: true, message: "请输入生产数量", trigger: "blur"},
        ],
        processing_cost: [
          {required: true, message: "请输入加工费用", trigger: "blur"},
        ],
        wastewater_num: [
          {required: true, message: "请输入废水数量", trigger: "blur"},
        ],
        wastegas_num: [
          {required: true, message: "请输入废气数量", trigger: "blur"},
        ],
        waste_solids_num: [
          {required: true, message: "请输入废固数量", trigger: "blur"},
        ],
        equipment_requirement: [
          {required: true, message: "请输入设备要求", trigger: "blur"},
        ],
        detile: [
          {required: true, message: "请输入需求详细描述", trigger: "blur"},
        ],
        upto_at: [
          {required: true, message: "请选择需求截止时间", trigger: "blur"},
          {
            validator: this.validateUptoDate,
            trigger: "change"
          }
        ],
        phone: [
          {required: true, message: "请输入手机号", trigger: "blur"},
          {
            pattern: /^1[3-9]\d{9}$/,
            message: "请输入正确的手机号码",
            trigger: "blur",
          },
        ],
      },
      tableData: [],
      device: [],
      total: 0,
      page: 1,
      pageSize: 10,
      selectRow: {},
      detail: {},
      featuredProcessingList: [],
    };
  },
  created() {
    this.getAreaOptions();
  },
  mounted() {
    this.init();
  },
  methods: {
    // 需求截止时间
    validateUptoDate(rule, value, callback) {
      if (value) {
        const selectedDate = new Date(value);
        const today = new Date();
        // 将时间部分设置为0，只比较日期部分
        selectedDate.setHours(0, 0, 0, 0);
        today.setHours(0, 0, 0, 0);

        if (selectedDate <= today) {
          callback(new Error('截止日期必须大于当前日期'));
        } else {
          callback();
        }
      } else {
        callback();
      }
    },

    changeFeaturedProcessing(e) {
      this.form.special_machining = e
    },
    async init() {
      this.processList();
      let res = await getDictValuesByKey({key: 'special_machining'})
      this.featuredProcessingList = res.data.values
    },
    // 查看
    handleClick(row) {
      this.selectRow = row;
      procesDetail(row.id).then((res) => {
        if (res.data.code === 10000) {
          let data = res.data.data;
          this.detail = data;
          this.detailVisible = true;
        }
      });
    },
    handleDelete(row) {
      this.$confirm('您确定要删除该内容？', '温馨提示', {
        distinguishCancelAndClose: true,
        confirmButtonText: '确认',
        cancelButtonText: '取消'
      })
          .then(() => {
            procesDelete(row.id).then(res => {
              if (res.data.code == 10000) {
                this.$message.success({
                  message: res.data.message,
                  duration: 1000,
                  offset: 200,
                });
                this.processList();
              } else {
                this.$message.error({
                  message: res.data.message,
                  duration: 1000,
                  offset: 200,
                });
              }
            })

          })

    },
    // 编辑
    handleEdit(row) {
      this.selectRow = row;
      procesDetail(row.id).then((res) => {
        if (res.data.code === 10000) {
          let data = res.data.data;
          if (data.type == 1) {
            this.formType = 1;
            this.form = {
              id: data.id,
              type: 1,
              title: data.title,
              phone: data.phone,
              park_name: data.park_name,
              park_level: data.park_level,
              space: data.space,
              worker_size: data.worker_size,
              work_type: data.work_type,
              small_libaray: data.small_libaray,
              website: data.website,
              address: [
                data.address.provinceId,
                data.address.cityId,
                data.address.areaId,
              ],
              special_machining: data.special_machining,
              temperature: data.temperature,
              three_wastes: {
                water: {
                  enable: data.three_wastes.water.enable,
                  number: data.three_wastes.water.number,
                  price: data.three_wastes.water.price,
                },
                tag: {
                  enable: data.three_wastes.tag.enable,
                  number: data.three_wastes.tag.number,
                  price: data.three_wastes.tag.price,
                },
                solid: {
                  enable: data.three_wastes.solid.enable,
                  number: data.three_wastes.solid.number,
                  price: data.three_wastes.solid.price,
                },
              },
              equipment: data.equipment,
              desc: data.desc,
            };
            this.checkList = data.special_machining
            this.equipmentList = data.equipment;
            this.dialogVisible = true;
          } else {
            this.formType = 2;
            this.formTwo = {
              id: data.id,
              type: 2,
              title: data.title,
              technology: data.technology,
              is_danger: data.is_danger,
              is_cert: data.is_cert,
              product_number: data.product_number,
              processing_cost: data.processing_cost,
              wastewater_num: data.wastewater_num,
              wastegas_num: data.wastegas_num,
              waste_solids_num: data.waste_solids_num,
              equipment_requirement: data.equipment_requirement,
              detile: data.detile,
              phone: data.phone,
              upto_at: data.upto_at,
            };
            this.dialogVisible = true;
          }
        }
      });

    },
    handleSearch() {
      this.page = 1;
      this.processList();
    },
    handleReset() {
      this.searchForm = {
        type: "",
        title: "",
        created_at: [],
      };
      this.processList();
    },
    // 获取加工供需列表
    processList() {
      this.loading = true;
      let data = JSON.parse(JSON.stringify(this.searchForm));
      data.page = this.page;
      data.limit = this.pageSize;
      processList(data).then((res) => {
        if (res.data.code === 10000) {
          this.tableData = res.data.data.data;
          this.total = res.data.data.total;
        }
        this.loading = false;
      });
    },
    changeType(val) {
      this.formType = val;
      this.form.type = 1;
      this.formTwo.type = 2;
      if (this.formType === 1) {
        this.$nextTick(() => {
          this.$refs.form.resetFields();
        });
      } else {
        this.$nextTick(() => {
          this.$refs.formTwo.resetFields();
        });
      }
    },
    // 获取省市区
    getAreaOptions() {
      getAreaOptions().then((res) => {
        this.areaOptions = res.data.data.map((item) => {
          return {
            value: item.id,
            label: item.name,
            children: item.children.map((item) => {
              return {
                value: item.id,
                label: item.name,
                children: item.children.map((item) => {
                  return {
                    value: item.id,
                    label: item.name,
                  };
                }),
              };
            }),
          };
        });
      });
    },
    // 新增设备和数量弹窗
    addDevice() {
      this.addDeviceVisible = true;
    },
    // 删除设备和数量
    deleteDevice(index, rowIndex) {
      this.equipmentList.splice(rowIndex, 1);
    },
    // 新增设备和数量
    addDeviceSubmit() {
      this.$refs.addDeviceForm.validate((valid) => {
        if (valid) {
          // this.addDeviceForm.id = this.equipmentList.length + 1;
          let data = JSON.parse(JSON.stringify(this.addDeviceForm));
          this.equipmentList.push(data);
          this.addDeviceVisible = false;
          this.$message.success({
            message: "添加成功",
            duration: 1000,
            offset: 200,
          });
          setTimeout(() => {
            this.$refs.addDeviceForm.resetFields();
          }, 1000);
        } else {
          return false;
        }
      });
    },
    // 新增
    handleRelease() {
      if (!this.mixCheckUserAudit()) {
        return
      }
      this.formType = 1;
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.form = {
          type: 1,
          title: "",
          phone: "",
          park_name: "",
          park_level: 1,
          space: "",
          worker_size: "",
          work_type: 1,
          small_libaray: 1,
          website: "",
          address: [],
          special_machining: 1,
          temperature: "",
          three_wastes: {
            water: {
              enable: 2,
              number: "",
              price: "",
            },
            tag: {
              enable: 2,
              number: "",
              price: "",
            },
            solid: {
              enable: 2,
              number: "",
              price: "",
            },
          },
          equipment: [],
          desc: "",
        };
        this.checkList = []
      });

    },
    // 关闭新增弹窗
    handleClose(done) {
      this.dialogVisible = false;
      if (this.formType === 1) {
        this.form = {
          type: 1,
          title: "",
          phone: "",
          park_name: "",
          park_level: 1,
          space: "",
          worker_size: "",
          work_type: 1,
          small_libaray: 1,
          website: "",
          address: [],
          special_machining: 1,
          temperature: "",
          three_wastes: {
            water: {
              enable: 2,
              number: "",
              price: "",
            },
            tag: {
              enable: 2,
              number: "",
              price: "",
            },
            solid: {
              enable: 2,
              number: "",
              price: "",
            },
          },
          equipment: [],
          desc: "",
        };
        this.checkList = []
      } else {
        this.formTwo = {
          type: 2,
          title: "",
          technology: '',
          is_danger: 1,
          is_cert: 1,
          product_number: "",
          processing_cost: "",
          wastewater_num: "",
          wastegas_num: "",
          waste_solids_num: "",
          equipment_requirement: "",
          detile: "",
          phone: "",
          upto_at: "",
        };
      }
    },
    // 校验新增表单
    submitForm() {
      if (this.formType === 1) {
        this.form.equipment = this.equipmentList.map((item, index) => {
          return {
            id: index,
            equip: item.equip,
            number: item.number,
          }
        })
        if (this.form.three_wastes.water.enable === 1) {
          if (this.$utils.isEmpty(this.form.three_wastes.water.number)) {
            this.$message.error({
              message: "请输入废水处理数量",
              duration: 1000,
              offset: 200,
            });
            return false;
          }
          if (this.$utils.isEmpty(this.form.three_wastes.water.price)) {
            this.$message.error({
              message: "请输入废水处理价格",
              duration: 1000,
              offset: 200,
            });
            return false;
          }
        }
        if (this.form.three_wastes.tag.enable === 1) {
          if (this.$utils.isEmpty(this.form.three_wastes.tag.number)) {
            this.$message.error({
              message: "请输入废气处理数量",
              duration: 1000,
              offset: 200,
            });
            return false;
          }
          if (this.$utils.isEmpty(this.form.three_wastes.tag.price)) {
            this.$message.error({
              message: "请输入废气处理价格",
              duration: 1000,
              offset: 200,
            });
            return false;
          }
        }
        if (this.form.three_wastes.solid.enable === 1) {
          if (this.$utils.isEmpty(this.form.three_wastes.solid.number)) {
            this.$message.error({
              message: "请输入废固处理数量",
              duration: 1000,
              offset: 200,
            });
            return false;
          }
          if (this.$utils.isEmpty(this.form.three_wastes.solid.price)) {
            this.$message.error({
              message: "请输入废固处理价格",
              duration: 1000,
              offset: 200,
            });
            return false;
          }
        }
        this.$refs.form.validate((valid) => {
          if (valid) {
            console.log("表单数据:", this.form);
            if (this.form.id) {
              this.pushEdit(this.form);
            } else {
              this.pushData(this.form);
            }
          } else {
            return false;
          }
        });
      } else {
        this.$refs.formTwo.validate((valid) => {
          if (valid) {
            console.log("表单数据:", this.formTwo);
            if (this.formTwo.id) {
              this.pushEdit(this.formTwo);
            } else {
              this.pushData(this.formTwo);
            }
          } else {
            return false;
          }
        });
      }
    },
    // 提交编辑数据
    pushEdit(data) {
      procesEdit(data.id, data).then((res) => {
        if (res.data.code === 10000) {
          this.$message.success({
            message: res.data.message,
            duration: 1000,
            offset: 200,
          });
          if (this.formType === 1) {
            this.$refs.form.resetFields();
          } else {
            this.$refs.formTwo.resetFields();
          }
          this.page = 1;
          this.processList();
          this.dialogVisible = false;
        } else {
          this.$message.error({
            message: res.data.message,
            duration: 1000,
            offset: 200,
          });
        }
      });
    },
    // 提交新增数据
    pushData(data) {
      processAdd(data).then((res) => {
        if (res.data.code === 10000) {
          this.$message.success({
            message: res.data.message,
            duration: 1000,
            offset: 200,
          });
          this.dialogVisible = false;
          this.page = 1;
          this.processList();
          if (this.formType === 1) {
            this.$refs.form.resetFields();
          } else {
            this.$refs.formTwo.resetFields();
          }
        } else {
          this.$message.error({
            message: res.data.message,
            duration: 1000,
            offset: 200,
          });
        }
      });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.processList();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.processList();
    },
  }
  ,
}
;
</script>

<style scoped lang="scss">
::v-deep .el-cascader {
  width: 100%;
}

::v-deep .el-form-item {
  width: 100%;
}

.margin-top {
  margin-top: 20px;
  text-align: center !important;
}

.text-center {
  text-align: center !important;
}

.detail-table {
  width: 100%;
  border-collapse: collapse;
  /* 关键：合并边框 */
  border-color: #f3f3f3;

  /* 新增样式规则 */
  td:nth-child(1),
  td:nth-child(3),
  td:nth-child(5) {
    //width: 150px;
    background: #f9faff;
    text-align: center;
    padding: 10px 10px;
    color: #5f616c;
    white-space: nowrap;
  }

  td:nth-child(2),
  td:nth-child(4),
  td:nth-child(6) {
    padding: 10px 24px;
    border: 1px solid #f3f3f3;
    color: #00112b;
  }
}

.post-page {
  padding-bottom: 100px;

  .top-box {
    ::v-deep .el-form-item {
      margin-bottom: 0;
    }

    ::v-deep .el-date-editor--daterange.el-input,
    .el-date-editor--daterange.el-input__inner,
    .el-date-editor--timerange.el-input,
    .el-date-editor--timerange.el-input__inner {
      width: 15vw;
    }

    // height: 220px;
    background: #ffffff;
    border-radius: 6px 6px 6px 6px;
    padding: 40px 30px;
    box-sizing: border-box;

    .input-box {
      display: flex;
      align-items: center;

      .input-title {
        width: 108px;
        font-weight: 400;
        font-size: 18px;
        color: #00112b;
        line-height: 25px;
      }

      .custom-input {
        width: 300px;

        ::v-deep .el-input__inner {
          height: 50px;
          line-height: 50px;
          border-radius: 4px;
          border-color: #dcdfe6;

          &:hover,
          &:focus {
            border-color: #409eff;
          }
        }
      }

      ::v-deep .el-date-editor.el-input {
        width: 100%;
      }
    }

    .line {
      height: 27px;
    }
  }

  .content-box {
    display: flex;
    justify-content: space-between;
    box-sizing: border-box;
    align-items: center;
    padding: 20px 0;

    .content-box-left {
      font-weight: 800;
      font-size: 20px;
      color: #00112b;
    }
  }

  .fotter-box {
    box-sizing: border-box;
    background: #ffffff;
    border-radius: 4px 4px 4px 4px;
    margin-bottom: 100px;
    padding: 20px;

    .operation {
      display: flex;
      justify-content: space-around;
      align-items: center;

      .el-button {
        font-weight: 500;
      }
    }
  }

  .pagination-box {
    padding-top: 20px;
    padding-left: 60px;
    text-align: right;
  }

  .button-group {
    justify-content: flex-end;

    .search-btn {
      margin-right: 15px;
    }

    .reset-btn {
      margin-left: 30px;
      width: 120px;
      height: 50px;
      border-radius: 4px 4px 4px 4px;
      border: 1px solid #5f616c;
      font-weight: 400;
      font-size: 18px;
      color: #5f616c;
    }
  }
}

::v-deep .el-dialog__header {
  border-bottom: 1px solid #e5e5e5;
}

.form-box {
  padding: 0 40px;

  ::v-deep .el-select {
    width: 100%;
  }

  .from-three {
    display: flex;
    align-items: center;

    .from-three-title {
      width: 150px;
      text-align: right;
    }

    .from-three-content {
      flex: 1;
      display: flex;
      flex-direction: column;
      gap: 20px;
    }
  }

  .table-from {
    margin-left: 65px;
    padding-bottom: 30px;

    .table-from-title {
      display: flex;
      justify-content: space-between;
      padding-bottom: 10px;
    }
  }
}
</style>
